<script>
    import PageComponentMixin from '../mixins/PageComponentMixin'

    const schema = {
        type: 'iframe',
        config: {
            // TODO REMOVE IFRAME AND LEAVE EMPTY
            "embedCode" : '<iframe width="560" height="315" src="https://www.youtube.com/embed/mlUjCWebXwY" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>'
        }
    }

    export default {
        name: 'Embed',
        schema,
        mixins : [PageComponentMixin],
        data () {
            return {
            }
        },
        render(h, context) {
            return h('div', {
                domProps: {

                    innerHTML: this.$componentData.embedCode
                }
            })
        },
    }
</script>